import endpointNames from "../configs/serverUrls";
import axios from "axios";


//url variables
const loginUrl = endpointNames.login;
const usersUrl = endpointNames.users;

//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//login function
const login = async (email, password) => {
    let response
    await axios.post(loginUrl, {
        'email': email,
        'password': password
    }).then((r) => {
        console.log("response ", r)
        response = r;
        localStorage.setItem('user', JSON.stringify(r));
    }).catch(err => {
        console.log("error ", err.response)
        response = err.response
    });

    return response;
};

//change password
const changePassword = async (request) => {
    let response;
    await axios.post(usersUrl.get + '/user/change-password', request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//save password
const savePassword = async (request) => {
    let response;
    await axios.post(usersUrl.get + '/user/savePassword', request)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//reset password
const resetPassword = async (request) => {
    let response;
    await axios.post(usersUrl.get + '/user/reset-password', request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err.response.data.message);
            response = err;
        });
    return response;
}

//logout
const logout = () => {
    localStorage.removeItem('user');
};


//get currentUser
const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user'));
};

//get all roles
const getAllRoles = async () => {
    let token = JSON.parse(localStorage.getItem('token'));
    let response;
    await axios.get(usersUrl.get + "/roles", {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

//get all users
const getAllUsers = async () => {
    let response;
    //gets user from localStorage
    let user = JSON.parse(localStorage.getItem('user'));
    //gets token from localStorage
    let token = JSON.parse(localStorage.getItem('token'));

    console.log("user: ", user);
    console.log("token: ", token);

    //create configuration with token
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    //include the config in your request
    await axios.get(usersUrl.get + "/users", {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res.data;
            console.log("res: ", response)
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}


//get one user
const getUser = async (id) => {
    //gets user from localStorage
    let user = JSON.parse(localStorage.getItem('user'));
    //gets token from localStorage
    let token = JSON.parse(localStorage.getItem('token'));

    console.log("user: ", user);
    console.log("token: ", token);

    let response;
    await axios.get(usersUrl.get + "/users/show/" + id, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        })

    return response
}


//activate user
const activate = async (id) => {
    let response;
    await axios.post(usersUrl.get + '/user/activate/' + id, {}, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//deactivate user
const deactivate = async (id) => {
    let response;
    await axios.post(usersUrl.get + '/user/de-activate/' + id, {}, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

// StoreUser / register user

const createAccount = async (request) => {
    console.log(request);
    let data = {
        'name': request.name,
        "firstName": request.firstName,
        "lastName": request.lastName,
        "email": request.email,
        'password': request.password,
        'role': request.role
    }

    let response;
    await axios.post(usersUrl.get + '/users/create', data, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const updateAccount = async (request) => {
    console.log(request);

    let response;
    await axios.patch(usersUrl.update + request.id, request, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const assignRole = async (role) => {
    let response;
    let data = {
        "id": role.id,
        "role_id": role.role_id
    }
    await axios.post(usersUrl.assign, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const unAssignRole = async (role) => {
    let response;
    let data = {
        "id": role.id,
        "role_id": role.role_id
    }
    await axios.post(usersUrl.unAssign, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const changeRole = async (role) => {
    let response;
    let data = {
        "id": role.id,
        "role_id": role.role_id
    }
    await axios.post(usersUrl.updateRole, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const assignDirectPermission = async (user) => {
    let response;
    let data = {
        'id': user.id,
        'permission': user.permission
    }
    await axios.post(usersUrl.assignDirect, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const unAssignDirectPermission = async (user) => {
    let response;
    let data = {
        'id': user.id,
        'permission': user.permission
    }
    await axios.post(usersUrl.unAssignDirect, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}


export default {
    login, changePassword, resetPassword, logout, getCurrentUser,
    getAllUsers, createAccount, getUser, getAllRoles, activate, deactivate, savePassword, updateAccount,
    assignRole, changeRole, unAssignRole, assignDirectPermission, unAssignDirectPermission

}
